import React, { ChangeEvent, useEffect, useState } from 'react';
import {
    IStructure,
    IStructureResponse,
} from '../../Models/Structure/IStructure';
import { PrimeService } from '../../Services/PrimeService';

interface StructureSelectProps {
    label: string;
    defaultOption: string;
    onSelectionChange: (structure: string) => void;
}
const SelectStructure: React.FC<StructureSelectProps> = ({
    label,
    defaultOption,
    onSelectionChange,
}) => {
    const [structures, setStructures] = useState<IStructure[]>([]);

    useEffect(() => {
        const getStructures = async () => {
            const structureData: IStructureResponse =
                await PrimeService.GetAllStructures();
            setStructures(structureData.data.structures);
        };
        void getStructures();
    }, []);

    const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
        const structureId = event.target.value;
        onSelectionChange(structureId);
    };

    return (
        <>
            {structures.length > 0 && (
                <div>
                    <label
                        htmlFor="supportStructure"
                        className={'col-12 mt-3 p-0'}
                        style={{ fontSize: '1.2rem' }}
                    >
                        {label}
                    </label>
                    <select
                        id="supportStructure"
                        className={'col-12 col-md-10 mt-2'}
                        onChange={handleChange}
                    >
                        <option value="">{defaultOption}</option>
                        {structures.map((sup) => (
                            <option
                                key={'structure' + sup.id}
                                value={sup.id.toString()}
                            >
                                {sup.nom}
                            </option>
                        ))}
                    </select>
                </div>
            )}
        </>
    );
};

export default SelectStructure;
